import React, { useEffect, useState, useRef } from "react";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import handleError from "../../../utils/handleError";
import { useDispatch, useSelector } from "react-redux";
import ClientTableSkeleton from "../../../components/Skeletons/ClientTableSkeleton";
import Pagination from "../../../utils/admin/pagination/Pagination";
import { Toast } from "primereact/toast";
import { getCategoriesForXMOT } from "../../../services/xmotSurvey/survey";
import { SET_STUDY_ID } from "../../../utils/constants";

const OtherActivities = () => {
  const toast = useRef(null);
  const tdStyle = { verticalAlign: "middle" };
  const lastSegment = location.pathname.split("/").pop();
  const [categoriesData, setCategoriesData] = useState([]);
  const [allCategoriesData, setAllCategoriesData] = useState([]);
  const [totalCategories, setTotalCategories] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const limit = 50;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const [searchValue, setSearchValue] = useState("");
  const match = location.pathname.match(/fromClient-(\d+)/);
  const clientId = match ? match[1] : null;

  const fetchXmotCategoriesData = (pageNum, searchParam = "") => {
    setLoading(true);
    const reqBody = {
      client_id: user.type === "superadmin" ? Number(clientId) : user.client_id,
    };
    getCategoriesForXMOT(token, reqBody)
      .then((response) => {
        const categories = response.data.data || [];
        setAllCategoriesData(categories);
        setCategoriesData(categories);
        setTotalCategories(categories.length);
        setLoading(false);
      })
      .catch((error) => {
        handleError(error, navigate, dispatch);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchXmotCategoriesData(page);
  }, [page]);

  useEffect(() => {
    if (!loading && allCategoriesData.length === 1) {
      handleViewResultsClick(allCategoriesData[0].study_id);
    }
  }, [allCategoriesData, loading]);

  const handlePrevPage = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    const maxPage = Math.ceil(totalCategories / limit);
    if (page < maxPage) setPage((prev) => prev + 1);
  };

  const renderHeaderAndControls = () => (
    <div
      className={`d-flex justify-content-between align-items-center px-3 py-2 ${
        categoriesData.length > 0 || loading ? "" : "my-3"
      }`}
    >
      <h6 className="fw-bold m-0 title">Categories</h6>
    </div>
  );

  const handleSearchCategory = (event) => {
    const searchTerm = event.target.value;
    setSearchValue(searchTerm);
    const normalizedSearchTerm = searchTerm.trim().toLowerCase();
    const filteredCategories = normalizedSearchTerm
      ? allCategoriesData.filter((category) =>
          category.category_name?.toLowerCase().includes(normalizedSearchTerm),
        )
      : allCategoriesData;

    setCategoriesData(filteredCategories);
    setTotalCategories(filteredCategories.length);
    setPage(1);
  };

  const renderSearchAndPagination = () => {
    const start = (page - 1) * limit + 1;
    const end = Math.min(page * limit, totalCategories);
    const isPrevDisabled = page === 1;
    const isNextDisabled = end >= totalCategories;

    return (
      <div className="d-flex justify-content-between align-items-center p-2">
        <div className="d-flex align-items-center">
          <span className="p-input-icon-left">
            <i
              className="pi pi-search"
              style={{ marginLeft: "320px", color: "#9e9e9e" }}
            ></i>
            <InputText
              placeholder="Search"
              style={{ borderRadius: "0px", width: "350px", fontWeight: "400" }}
              className="inputField"
              autoComplete="off"
              name="search-user-input"
              value={searchValue}
              onChange={handleSearchCategory}
            />
          </span>
        </div>
        {/* <Pagination
            start={start}
            end={end}
            totalClients={totalCategories}
            isPrevDisabled={isPrevDisabled}
            isNextDisabled={isNextDisabled}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            /> */}

        <Toast ref={toast} />
      </div>
    );
  };

  const handleViewResultsClick = (studyId) => {
    dispatch({
      type: SET_STUDY_ID,
      payload: studyId,
    });
    const path =
      user.type === "superadmin"
        ? `/admin-panel/other-activities/view-results/${lastSegment}`
        : `/dashboard/other-activities/view-results`;
    navigate(path, {
      state: {
        categoryLength: categoriesData?.length,
        tabVal: "other_activity",
      },
    });
  };

  return (
    <>
      <div className="container-fluid page-wrapper">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card shadow-card" style={{ minHeight: "590px" }}>
              {categoriesData.length ? renderHeaderAndControls() : ""}
              <Divider
                style={{
                  margin: "0.5rem 0 !important",
                  padding: "0 1rem !important",
                }}
              />
              <div className="table-responsive">
                {renderSearchAndPagination()}
                <Divider />
                <table className="table table-borderless clientsTable">
                  <thead className="clientsTableHead">
                    <tr className="text-muted" style={{ fontSize: "12px" }}>
                      <th style={{ width: "6%" }}>Sr #</th>
                      <th>Category Name </th>
                      <th>Analyze</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <ClientTableSkeleton />
                    ) : categoriesData.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-muted">
                          No records found
                        </td>
                      </tr>
                    ) : (
                      categoriesData.map((categoryData, index) => (
                        <tr key={index}>
                          <td>{(page - 1) * limit + index + 1}</td>
                          <td>{categoryData.category_name}</td>
                          <td style={tdStyle}>
                            <span
                              className="text-primary"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleViewResultsClick(categoryData.study_id)
                              }
                            >
                              View Results
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherActivities;
